import {
  EngagementFeedsPagedResponse,
  EngagementFeedWithUser,
  NewsfeedResponseDto,
  NewsfeedResponseDtoPageResponseDto,
} from '@epicuro-next/data/engagement/engagement-models';
import { IUser } from '@epicuro-next/data/users';
import { isNonNullish } from '@epicuro-next/utilities';
import { decode } from 'html-entities';

import { mapEngagementMediaToLegacy } from '../engagement-list-mappers/engagement-list-mappers';

export function mapEngagementSystemToLegacyFeed(
  resp: NewsfeedResponseDtoPageResponseDto,
  userEntities: IUser[],
): EngagementFeedsPagedResponse {
  return {
    total: resp.total ?? 0,
    items: (resp.items ?? []).map((item) => {
      return mapEngagementFeedToLegacy(item, userEntities);
    }),
  };
}

// When delete mapping - move decode logic to other place (map in service response)
export function mapEngagementFeedToLegacy(
  engagementFeed: NewsfeedResponseDto,
  userEntities: IUser[],
): EngagementFeedWithUser {
  const userId = engagementFeed.referenceCreatedByUserId ?? '';
  const owner = userEntities.find((e) => e.externalId === userId);

  const feed = {
    ...engagementFeed,
    title: decode(engagementFeed.title),
    userId,
    updatedAtUtc: engagementFeed.createdAtUtc, // Need to create ticket on engagement
    references: engagementFeed.references?.map((r) => ({
      ...r,
      media: mapEngagementMediaToLegacy(r.media),
      name: decode(r.name),
      description: decode(r.description),
    })),
    media: engagementFeed.media
      ? mapEngagementMediaToLegacy(engagementFeed.media)
      : undefined,
  } as EngagementFeedWithUser;

  if (engagementFeed?.properties) {
    const properties = engagementFeed.properties;
    feed.properties = {
      siteId: properties.siteId,
      subSiteId: properties?.subSiteId,
    };
  }

  if (isNonNullish(owner)) {
    const { displayName, imageLink } = owner;

    feed.displayName = displayName;
    feed.userProfilePictureUrl = imageLink;
  }

  return feed;
}
